import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=61465c3e&scoped=true&lang=pug"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"
import style0 from "./Profile.vue?vue&type=style&index=0&id=61465c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61465c3e",
  null
  
)

export default component.exports